var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.request
    ? _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col lg:w-3/5 w-full" },
          [
            _c(
              "vx-card",
              [
                _c(
                  "div",
                  { staticClass: "flex justify-between items-center mb-4" },
                  [
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(_vm.$t("cancellation.timeline")) +
                          " · " +
                          _vm._s(_vm.request.protocol)
                      ),
                    ]),
                    _c(
                      "vs-chip",
                      {
                        staticClass: "text-base",
                        attrs: {
                          transparent: "",
                          color: _vm.statusColor(_vm.request.status),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "cancellation.request_status_." +
                                  _vm.request.status
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "app-timeline",
                  _vm._l(_vm.request.events, function (event) {
                    return _c("app-timeline-item", {
                      key: event.id,
                      attrs: {
                        title: event.title,
                        subtitle: event.description || "",
                        time: _vm.formatDateTime(event.happened_at),
                        icon: _vm.eventIcon(event.event_type),
                        variant: _vm.eventVariant(event.event_type),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col lg:w-2/5 w-full" },
          [
            _c("vx-card", { staticClass: "mb-4" }, [
              _c("h4", { staticClass: "mb-3" }, [
                _vm._v(_vm._s(_vm.$t("cancellation.policy_at_booking"))),
              ]),
              _c("div", { staticClass: "border rounded p-1" }, [
                _c("div", { staticClass: "flex justify-between mb-1" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.version"))),
                  ]),
                  _vm.request.policy_version
                    ? _c("small", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.policyName) +
                            " v" +
                            _vm._s(_vm.request.policy_version.version) +
                            " "
                        ),
                      ])
                    : _c("small", [_vm._v("—")]),
                ]),
                _c("div", { staticClass: "flex justify-between mb-1" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.applied_tier"))),
                  ]),
                  _c("small", [_vm._v(_vm._s(_vm.tierLabel))]),
                ]),
                _c("div", { staticClass: "flex justify-between mb-1" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.reason"))),
                  ]),
                  _vm.isMedicalReason
                    ? _c(
                        "small",
                        { staticClass: "text-danger font-weight-bold" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("cancellation.reason_.ME")) +
                              " "
                          ),
                        ]
                      )
                    : _c("small", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.request.reason_text ||
                                _vm.$t(
                                  "cancellation.reason_." + _vm.request.reason
                                )
                            ) +
                            " "
                        ),
                      ]),
                ]),
                _vm.isMedicalReason
                  ? _c("div", { staticClass: "mb-1" }, [
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          " Dado de saúde (LGPD, Art. 5º, II). Use apenas para decidir este pedido. Nenhuma descrição é guardada — peça o atestado ao aluno se precisar. "
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "flex justify-between mb-1" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.medical_exception"))),
                  ]),
                  _vm.medicalEnabled
                    ? _c("small", { staticClass: "text-success" }, [
                        _vm._v("Habilitada"),
                      ])
                    : _c("small", { staticClass: "text-danger" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("cancellation.not_enabled_in")) +
                            " v" +
                            _vm._s(
                              _vm.request.policy_version
                                ? _vm.request.policy_version.version
                                : "—"
                            ) +
                            " "
                        ),
                      ]),
                ]),
              ]),
            ]),
            _c(
              "vx-card",
              [
                _c("h4", { staticClass: "mb-3" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.decision"))),
                ]),
                _c(
                  "b-form-group",
                  [
                    _c("b-form-radio-group", {
                      staticClass: "required",
                      attrs: { options: _vm.decisionOptions, stacked: "" },
                      model: {
                        value: _vm.decision.decision,
                        callback: function ($$v) {
                          _vm.$set(_vm.decision, "decision", $$v)
                        },
                        expression: "decision.decision",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("cancellation.absorbed_by") } },
                  [
                    _c("b-form-select", {
                      staticClass: "required",
                      attrs: { options: _vm.absorbedByOptions },
                      model: {
                        value: _vm.decision.absorbed_by,
                        callback: function ($$v) {
                          _vm.$set(_vm.decision, "absorbed_by", $$v)
                        },
                        expression: "decision.absorbed_by",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("cancellation.justification") } },
                  [
                    _c("b-form-textarea", {
                      attrs: {
                        placeholder: _vm.$t(
                          "cancellation.justification_placeholder"
                        ),
                        rows: "3",
                      },
                      model: {
                        value: _vm.decision.justification,
                        callback: function ($$v) {
                          _vm.$set(_vm.decision, "justification", $$v)
                        },
                        expression: "decision.justification",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex gap-4" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "cancellation_movements.edit",
                            expression: "'cancellation_movements.edit'",
                          },
                        ],
                        staticClass: "mr-2",
                        attrs: {
                          variant: "primary",
                          disabled:
                            !_vm.decision.decision || !_vm.decision.absorbed_by,
                        },
                        on: { click: _vm.decide },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("cancellation.decide_execute")) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-secondary" },
                        on: { click: _vm.askMoreInfo },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("cancellation.ask_more_info")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }